import Article from "../pages/article/[slug]";

const contentful = require("contentful");
const client = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: "o2vns12cx9ua",
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: "V9nVc3GxNjaWq-D9bKRRdvL3rOBCfum4E7hugzBTEvg",
});
// This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.

// type GetArticleParams = {
//   pageContentType: string;
//   slug: string;
// };

type Article = {
  slug: string;
  title: string;
  image: string;
};

export const getArticles = async (numArticles = 10) => {
  const query = {
    limit: numArticles,
    include: numArticles,
    content_type: "article",
  };
  const articles = await client.getEntries(query);
  // console.log("Article items are ", articles.items);
  return articles.items || null;
};

export const getArticle = async (slug) => {
  const query = {
    limit: 1,
    "fields.slug": slug,
    include: 10,
    content_type: "article",
  };
  const article = await client.getEntries(query);
  return article || null;
};
